import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import { SecurityHero, SecurityContent } from '../components/SecurityPageSections';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const SecurityPage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Security Systems Carrum - CCTV & Alarms"
        description="Professional security system installation in Carrum and Bayside Melbourne. CCTV, alarm systems, access control and intercoms. Licensed and trusted."
        keywords="security systems Carrum, CCTV installation Bayside Melbourne, alarm systems Carrum, access control Melbourne, intercom installation"
        canonical="https://securelec.net.au/what-we-do/security"
      />
      <Header />
      <main>
        <SecurityHero />
        <SecurityContent />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default SecurityPage;
